import React from "react";
import { Table, Dropdown, Menu, Button, Space } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { getMenuItems } from "../../actions/merchant_actions";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export default function MenuItems({ products, onEdit, onDelete }) {
  const { accUrn } = useParams();

  const {
    refetch,
    isLoading,
    data: itemsData,
  } = useQuery({
    queryKey: ["menuItems", accUrn],
    queryFn: () => getMenuItems({ account_urn: accUrn }),
    enabled: accUrn ? true : false,
  });

  const columns = [
    {
      title: "SKU",
      dataIndex: ["data", "sku"],
      key: "sku",
    },
    {
      title: "Name",
      dataIndex: ["data", "name"],
      key: "name",
    },
    {
      title: "Title",
      dataIndex: ["data", "title"],
      key: "title",
    },
    {
      title: "Type",
      dataIndex: ["data", "type"],
      key: "type",
    },
    {
      title: "Usage",
      dataIndex: ["data", "usage"],
      key: "usage",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const menu = (
          <Menu>
            <Menu.Item key="edit" onClick={() => onEdit?.(record)}>
              Edit
            </Menu.Item>
            <Menu.Item key="delete" danger onClick={() => onDelete?.(record)}>
              Delete
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu}>
            <Button icon={<MoreOutlined />} />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <Table
      loading={isLoading}
      dataSource={itemsData}
      columns={columns}
      rowKey="urn"
      pagination={false}
      size="middle"
    />
  );
}
